/* HypeVendz theme JS — vanilla, no dependencies. */
(function () {
  'use strict';

  /* ── Mobile nav ─────────────────────────────── */
  var toggle = document.querySelector('.hv-menu-toggle');
  var nav = document.querySelector('.hv-nav');
  if (toggle && nav) {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var header = toggle.closest('.hv-header');
        if (header) nav.style.top = header.getBoundingClientRect().bottom + 'px';
      }
    });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('open') && !nav.contains(e.target) && !toggle.contains(e.target)) {
        nav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ── Cart count badge ───────────────────────── */
  function updateCartCount(count) {
    var els = document.querySelectorAll('.hv-cart-count');
    if (els.length) {
      els.forEach(function (el) { el.textContent = count; });
    } else if (count > 0) {
      document.querySelectorAll('a.hv-header-icon[href*="cart"]').forEach(function (link) {
        var badge = document.createElement('span');
        badge.className = 'hv-cart-count';
        badge.textContent = count;
        link.appendChild(badge);
      });
    }
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  /* ── Card quick add (delegated) ─────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hv-card-atc');
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var icon = btn.querySelector('.hv-atc-icon');
    var check = btn.querySelector('.hv-atc-check');
    btn.disabled = true;
    addToCart(variantId)
      .then(function () {
        if (icon) icon.style.display = 'none';
        if (check) check.style.display = '';
      })
      .catch(function () {})
      .finally(function () {
        setTimeout(function () {
          if (icon) icon.style.display = '';
          if (check) check.style.display = 'none';
          btn.disabled = false;
        }, 2000);
      });
  });

  /* ── Product form: AJAX add to cart ─────────── */
  var form = document.getElementById('hv-product-form');
  var atcBtn = document.getElementById('hv-atc-main');
  if (form && atcBtn) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var select = document.getElementById('hv-variant-select');
      var variantId = select ? select.value : null;
      if (!variantId) return;
      var original = atcBtn.textContent;
      atcBtn.textContent = 'Adding…';
      atcBtn.disabled = true;
      addToCart(variantId)
        .then(function () { atcBtn.textContent = '✓ Added to cart'; })
        .catch(function () { atcBtn.textContent = original; })
        .finally(function () {
          setTimeout(function () {
            atcBtn.textContent = original;
            atcBtn.disabled = false;
          }, 2200);
        });
    });
  }

  /* ── Variant pills sync the hidden select ───── */
  var variantSelect = document.getElementById('hv-variant-select');
  document.querySelectorAll('.hv-variant-btns').forEach(function (group) {
    var btns = group.querySelectorAll('.hv-variant-btn');
    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (variantSelect && variantSelect.options[i] && !variantSelect.options[i].disabled) {
          variantSelect.value = variantSelect.options[i].value;
          var buyNow = document.getElementById('hv-buy-main');
          var sticky = document.querySelector('.hv-sticky-btn[data-checkout]');
          var href = '/cart/' + variantSelect.value + ':1?checkout';
          if (buyNow) buyNow.setAttribute('href', href);
          if (sticky) sticky.setAttribute('href', href);
        }
      });
    });
  });

  /* ── Sticky buy bar (product) ───────────────── */
  var stickyBar = document.getElementById('hv-sticky');
  var anchorCta = document.getElementById('hv-buy-main') || atcBtn;
  if (stickyBar && anchorCta) {
    var checkSticky = function () {
      var r = anchorCta.getBoundingClientRect();
      stickyBar.classList.toggle('hv-hidden', r.bottom > 0 && r.top < window.innerHeight);
    };
    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  }

  /* ── Scroll reveal (skipped for reduced motion) ── */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    document.documentElement.classList.add('no-reveal');
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  } else if (revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ── Collection filter chips (links kept crawlable) ── */
  var chipWrap = document.querySelector('.hv-filter-chips');
  if (chipWrap) {
    var cards = document.querySelectorAll('.hv-grid [data-tags]');
    chipWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter]');
      if (!chip) return;
      e.preventDefault();
      var tag = chip.getAttribute('data-filter');
      chipWrap.querySelectorAll('[data-filter]').forEach(function (c) { c.classList.remove('active'); });
      chip.classList.add('active');
      cards.forEach(function (card) {
        var tags = ' ' + (card.getAttribute('data-tags') || '') + ' ';
        var show = tag === 'all' || tags.indexOf(' ' + tag + ' ') !== -1;
        card.classList.toggle('hv-card-hidden', !show);
      });
    });
  }
})();
